import getFromCdn from '@anm/helpers/getFromCdn';
import styled from 'styled-components';

export const CardIcons = styled.div``;

export const CardFrontView = styled.div`
  background-color: #ebeef5;
  background-image: url(${getFromCdn(
    'images/icons/credit-card-icons/payment-logos.svg'
  )});
  background-position: right 30px top 20px;
  background-size: 43%;
  background-repeat: no-repeat;
  padding: 54px 10px 17px 10px;
  border-radius: 5px;
  width: 80%;
  position: relative;
  z-index: 2;
  flex: 1 1 400px;
`;

export const EditCardView = styled.div`
  background-color: #ced1d8;
  border-radius: 5px;
  display: flex;
  align-items: flex-end;
  position: relative;
  flex-wrap: wrap;
  margin: 0 10px 17px;
  &:after {
    display: block;
    width: 100%;
    height: 40px;
    content: '';
    background-color: #292a2b;
    top: 35px;
    right: 0;
    position: absolute;
    z-index: 1;
  }
`;

export const CardCvcFieldWrapper = styled.div`
  margin: 18px 18px 27px 22px;
  flex: 1 1 60px;
`;

export const CardFrontViewRow = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
`;

export const CardNumberFieldWrapper = styled.div`
  margin: 10px;
`;

export const CardFrontViewExpiresBlock = styled.div`
  display: flex;
  flex: 1 1 120px;
  margin: 10px;
  align-items: flex-end;
`;

export const CardFrontViewNameBlock = styled.div`
  margin: 10px;
  flex: 1 1 220px;
`;

export const Slash = styled.span`
  margin: 0 5px 10px;
`;
